import { Moment } from 'moment';

export class BaseModel {
    public id!: number;
    public created_at!: Moment;
    public updated_at!: Moment;
}
